import { ApiClient } from '../client/ApiClient';
import { LineItemProps } from './types';
import { ApiResponse } from '../types';
import { CountryCode, getMultiTenancyHeaders } from '../utils/multiTenancyHeaders';

export interface SuggestionsApiRequest {
  sourceSystem: string;
  suggestionMarkupFormat: string;
  lineItems: Array<{
    productSku: number;
    finalProductPriceInc: number;
  }>;
}

export interface SuggestionsApiResponse {
  errorMessage: string | null;
  lineItems: Array<LineItemProps>;
}

export class ServicesApiClient extends ApiClient {
  protected static _refreshUrl = null;
  private readonly _serviceSuggestionsUrl: string;
  private readonly _countryCode: CountryCode;

  constructor({ serviceSuggestionsUrl, countryCode }: { serviceSuggestionsUrl: string; countryCode: CountryCode }) {
    super();
    this._serviceSuggestionsUrl = serviceSuggestionsUrl;
    this._countryCode = countryCode;
  }

  protected override get requestHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...getMultiTenancyHeaders(this._countryCode),
    };
  }

  getSuggestions = async (body: SuggestionsApiRequest): Promise<ApiResponse<SuggestionsApiResponse>> => {
    const { data, statusCode, error } = await this._fetch<SuggestionsApiResponse>({
      path: this._serviceSuggestionsUrl,
      method: 'POST',
      body,
    });

    if (error) {
      return { error, statusCode };
    }

    return { data: data, error: error, statusCode };
  };
}
